export default "__VITE_ASSET__f$ngpMBq__"